import { ActionType } from '../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../core/api/rsaa';
import { Endpoints } from '../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../core/api/module';
import * as R from 'ramda';


const KEY_ACTION = ActionType.UpdateConfidentialityRequest;
const ACTIONS    = [
  ActionType.UpdateConfidentialityRequest,
  ActionType.UpdateConfidentialityResponse,
  ActionType.UpdateConfidentialityError,
];


/**
 * Dispatch this action to accept the project confidentiality agreement for the given user/project IDs
 */
export const updateConfidentialityAction = (personId: number, projectId: number) => makeApiAction({
  method:   'POST',
  endpoint: Endpoints.UpdateConfidentiality,
  headers:  { 'content-type': 'application/json' },
  body:     JSON.stringify({ projectId: projectId, participantId: personId }),
  types:    makeRsaaTypes(ACTIONS, { personId, projectId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer = (state, action, errorMsg, isLoading) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['projectSummary', 'confidentialRequired'], false, successState);
};


export const updateConfidentialityReducer = makeApiReducer(ACTIONS, KEY_ACTION, reducer);
